module.exports = __webpack_public_path__ + "static/media/star_icon.0530fd84.svg";